const aiBidRoutes = [
  {
    path: '/ai-bid/buy',
    name: 'AiBidBuy',
    component: () => import('@/views/ai-bid/buy.vue'),
    meta: {
      layout: 'DefaultLayout',
      title: '标书生成购买'
    }
  }
]

export default aiBidRoutes
